import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/Bailout';

// 「取得「保經濟弱勢保戶保單借款優惠利率」方案申請說明
export function getAgreeTermsBailout() {
    return get(`${url}/getAgreeTerms`);
}
// 申請條款同意
export function postAgreeBailout() {
    return post(`${url}/agree`);
}
// 「保經濟弱勢保戶保單借款優惠利率」申請保單內容
export function getBailout() {
    return get(`${url}/info`);
}
// 送出紓困申請金額與附件
export function submitBailout(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true, formData: true });
}
